import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_selectionStart2vknrfox4u4l8 as get_selectionStart,
  get_selectionEnd2du62zn9takrg as get_selectionEnd,
  setSelectionRange10xzbpb686fcx as setSelectionRange,
} from './FormattedTextInput.commonHtml.js.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Char19o2r8palgjof as Char } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set1y8eiqnqugbz3 as set,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  get_state389x218zizu8a as get_state,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { RViewWithActionov1gis5vq13n as RViewWithAction } from '../RView.mjs';
import { KeyCodes_instancevfnkc2xsbiba as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
import {
  KeyboardHints3coyq4x1rsbe3 as KeyboardHints,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
} from '../../models/data.mjs';
import { applyKeyboardHints2y8fo0b5cldu1 as applyKeyboardHints } from './KeyboardHints.ext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function FormattedTextInput$formatter$lambda(it) {
  return it;
}
function FormattedTextInput$isRawData$lambda(it) {
  return true;
}
var FormattedTextInput$content$1Class;
function FormattedTextInput$content$1() {
  if (FormattedTextInput$content$1Class === VOID) {
    class $ extends BaseListenable() {
      static ibq(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.hbq_1 = this$0;
        var $this = this.uam($box);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this$0.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('input', (it) => {
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            var tmp = this$0.vb5_1.bb4_1.kb7_1.value;
            var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
            var tmp0 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
            var tmp2 = get_selectionStart(this$0);
            var tmp4 = get_selectionEnd(this$0);
            var tmp6 = this$0.wbr_1;
            // Inline function 'com.lightningkite.kiteui.utils.repairFormatAndPosition' call
            var formatter = this$0.vbr_1;
            // Inline function 'kotlin.text.filter' call
            // Inline function 'kotlin.text.filterTo' call
            var destination = StringBuilder().d1();
            var inductionVariable = 0;
            var last = charSequenceLength(tmp0);
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element = charSequenceGet(tmp0, index);
                if (tmp6(new (Char())(element))) {
                  destination.xb(element);
                }
              }
               while (inductionVariable < last);
            var clean = destination.toString();
            var result = formatter(clean);
            var tmp_0;
            if (tmp2 == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.text.count' call
              var count = 0;
              var indexedObject = substring(tmp0, 0, tmp2);
              var inductionVariable_0 = 0;
              while (inductionVariable_0 < charSequenceLength(indexedObject)) {
                var element_0 = charSequenceGet(indexedObject, inductionVariable_0);
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                if (!tmp6(new (Char())(element_0))) {
                  count = count + 1 | 0;
                }
              }
              tmp_0 = tmp2 - count | 0;
            }
            var startPosOnClean = tmp_0;
            var tmp_1;
            if (tmp4 == null) {
              tmp_1 = null;
            } else {
              // Inline function 'kotlin.text.count' call
              var count_0 = 0;
              var indexedObject_0 = substring(tmp0, 0, tmp4);
              var inductionVariable_1 = 0;
              while (inductionVariable_1 < charSequenceLength(indexedObject_0)) {
                var element_1 = charSequenceGet(indexedObject_0, inductionVariable_1);
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                if (!tmp6(new (Char())(element_1))) {
                  count_0 = count_0 + 1 | 0;
                }
              }
              tmp_1 = tmp4 - count_0 | 0;
            }
            var endPosOnClean = tmp_1;
            var tmp_2;
            if (startPosOnClean == null) {
              tmp_2 = null;
            } else {
              // Inline function 'kotlin.let' call
              var remaining = startPosOnClean;
              var count_1 = 0;
              $l$loop: while (remaining > 0 && count_1 < result.length) {
                var _unary__edvuaz = count_1;
                count_1 = _unary__edvuaz + 1 | 0;
                if (tmp6(new (Char())(charCodeAt(result, _unary__edvuaz))))
                  remaining = remaining - 1 | 0;
              }
              tmp_2 = count_1;
            }
            var startPosOnResult = tmp_2;
            var tmp_3;
            if (endPosOnClean == null) {
              tmp_3 = null;
            } else {
              // Inline function 'kotlin.let' call
              var remaining_0 = endPosOnClean;
              var count_2 = 0;
              $l$loop_0: while (remaining_0 > 0 && count_2 < result.length) {
                var _unary__edvuaz_0 = count_2;
                count_2 = _unary__edvuaz_0 + 1 | 0;
                if (tmp6(new (Char())(charCodeAt(result, _unary__edvuaz_0))))
                  remaining_0 = remaining_0 - 1 | 0;
              }
              tmp_3 = count_2;
            }
            var endPosOnResult = tmp_3;
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            this$0.vb5_1.bb4_1.kb7_1.value = result;
            if (!(startPosOnResult == null) && !(endPosOnResult == null)) {
              setSelectionRange(this$0, startPosOnResult, endPosOnResult);
            }
            $this.mal();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.gb4_1['on' + 'input'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'input';
          this_0.gb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            var tmp = this$0.vb5_1.bb4_1.kb7_1.value;
            var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
            var tmp0 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
            var tmp2 = get_selectionStart(this$0);
            var tmp4 = get_selectionEnd(this$0);
            var tmp6 = this$0.wbr_1;
            // Inline function 'com.lightningkite.kiteui.utils.repairFormatAndPosition' call
            var formatter = this$0.vbr_1;
            // Inline function 'kotlin.text.filter' call
            // Inline function 'kotlin.text.filterTo' call
            var destination = StringBuilder().d1();
            var inductionVariable = 0;
            var last = charSequenceLength(tmp0);
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element = charSequenceGet(tmp0, index);
                if (tmp6(new (Char())(element))) {
                  destination.xb(element);
                }
              }
               while (inductionVariable < last);
            var clean = destination.toString();
            var result = formatter(clean);
            var tmp_0;
            if (tmp2 == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.text.count' call
              var count = 0;
              var indexedObject = substring(tmp0, 0, tmp2);
              var inductionVariable_0 = 0;
              while (inductionVariable_0 < charSequenceLength(indexedObject)) {
                var element_0 = charSequenceGet(indexedObject, inductionVariable_0);
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                if (!tmp6(new (Char())(element_0))) {
                  count = count + 1 | 0;
                }
              }
              tmp_0 = tmp2 - count | 0;
            }
            var startPosOnClean = tmp_0;
            var tmp_1;
            if (tmp4 == null) {
              tmp_1 = null;
            } else {
              // Inline function 'kotlin.text.count' call
              var count_0 = 0;
              var indexedObject_0 = substring(tmp0, 0, tmp4);
              var inductionVariable_1 = 0;
              while (inductionVariable_1 < charSequenceLength(indexedObject_0)) {
                var element_1 = charSequenceGet(indexedObject_0, inductionVariable_1);
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                if (!tmp6(new (Char())(element_1))) {
                  count_0 = count_0 + 1 | 0;
                }
              }
              tmp_1 = tmp4 - count_0 | 0;
            }
            var endPosOnClean = tmp_1;
            var tmp_2;
            if (startPosOnClean == null) {
              tmp_2 = null;
            } else {
              // Inline function 'kotlin.let' call
              var remaining = startPosOnClean;
              var count_1 = 0;
              $l$loop_1: while (remaining > 0 && count_1 < result.length) {
                var _unary__edvuaz = count_1;
                count_1 = _unary__edvuaz + 1 | 0;
                if (tmp6(new (Char())(charCodeAt(result, _unary__edvuaz))))
                  remaining = remaining - 1 | 0;
              }
              tmp_2 = count_1;
            }
            var startPosOnResult = tmp_2;
            var tmp_3;
            if (endPosOnClean == null) {
              tmp_3 = null;
            } else {
              // Inline function 'kotlin.let' call
              var remaining_0 = endPosOnClean;
              var count_2 = 0;
              $l$loop_2: while (remaining_0 > 0 && count_2 < result.length) {
                var _unary__edvuaz_0 = count_2;
                count_2 = _unary__edvuaz_0 + 1 | 0;
                if (tmp6(new (Char())(charCodeAt(result, _unary__edvuaz_0))))
                  remaining_0 = remaining_0 - 1 | 0;
              }
              tmp_3 = count_2;
            }
            var endPosOnResult = tmp_3;
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            this$0.vb5_1.bb4_1.kb7_1.value = result;
            if (!(startPosOnResult == null) && !(endPosOnResult == null)) {
              setSelectionRange(this$0, startPosOnResult, endPosOnResult);
            }
            $this.mal();
            return Unit_instance;
          };
        }
        return $this;
      }
      abs(value) {
        // Inline function 'kotlin.text.filter' call
        var predicate = this.hbq_1.wbr_1;
        // Inline function 'kotlin.text.filterTo' call
        var destination = StringBuilder().d1();
        var inductionVariable = 0;
        var last = charSequenceLength(value);
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = charSequenceGet(value, index);
            if (predicate(new (Char())(element))) {
              destination.xb(element);
            }
          }
           while (inductionVariable < last);
        var clean = destination.toString();
        var formatted = this.hbq_1.vbr_1(clean);
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var tmp = this.hbq_1.vb5_1.bb4_1.kb7_1.value;
        if (!(((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null) === formatted)) {
          // Inline function 'com.lightningkite.kiteui.views.valueString' call
          this.hbq_1.vb5_1.bb4_1.kb7_1.value = formatted;
        }
        this.mal();
      }
      oam(_set____db54di) {
        return this.abs((!(_set____db54di == null) ? typeof _set____db54di === 'string' : false) ? _set____db54di : THROW_CCE());
      }
      f2() {
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var tmp = this.hbq_1.vb5_1.bb4_1.kb7_1.value;
        var tmp0_safe_receiver = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.text.filter' call
          var predicate = this.hbq_1.wbr_1;
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder().d1();
          var inductionVariable = 0;
          var last = charSequenceLength(tmp0_safe_receiver);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(tmp0_safe_receiver, index);
              if (predicate(new (Char())(element))) {
                destination.xb(element);
              }
            }
             while (inductionVariable < last);
          tmp_0 = destination.toString();
        }
        var tmp1_elvis_lhs = tmp_0;
        return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      }
      qam(thisRef, property) {
        return this.pam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      sam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.ram(tmp, property, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
    }
    protoOf($).eak = valueSet;
    protoOf($).iah = set;
    protoOf($).pam = getValue;
    protoOf($).ram = setValue;
    protoOf($).vak = lens;
    protoOf($).dak = lens_0;
    protoOf($).sah = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue(), BaseListenable()], [1]);
    FormattedTextInput$content$1Class = $;
  }
  return FormattedTextInput$content$1Class;
}
var FormattedTextInputClass;
function FormattedTextInput() {
  if (FormattedTextInputClass === VOID) {
    class $ extends RViewWithAction() {
      constructor(context) {
        super(context);
        this.vb5_1.zb3_1 = 'input';
        this.vb5_1.jb4_1.v('editable');
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.iax()) {
              var tmp0_safe_receiver = this.mbg_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.zbe(this);
              }
            }
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.gb4_1['on' + 'keyup'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'keyup';
          this_0.gb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.iax()) {
              var tmp0_safe_receiver_0 = this.mbg_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.zbe(this);
              }
            }
            return Unit_instance;
          };
        }
        var tmp_2 = this;
        tmp_2.vbr_1 = FormattedTextInput$formatter$lambda;
        var tmp_3 = this;
        tmp_3.wbr_1 = FormattedTextInput$isRawData$lambda;
        var tmp_4 = this;
        tmp_4.xbr_1 = FormattedTextInput$content$1().ibq(this);
        this.ybr_1 = new (KeyboardHints())();
        this.zbr_1 = Align_Start_getInstance();
      }
      bbs(isRawData, formatter) {
        this.vbr_1 = formatter;
        this.wbr_1 = isRawData;
      }
      cbs(value) {
        this.ybr_1 = value;
        applyKeyboardHints(this.vb5_1, value);
      }
      dbs(value) {
        this.zbr_1 = value;
        var tmp0 = this.vb5_1.db4_1;
        var tmp;
        switch (value.b4_1) {
          case 0:
            tmp = 'start';
            break;
          case 1:
            tmp = 'center';
            break;
          case 2:
            tmp = 'end';
            break;
          case 3:
            tmp = 'justify';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        // Inline function 'com.lightningkite.kiteui.views.textAlign' call
        var value_0 = tmp;
        tmp0.hb7_1.textAlign = value_0;
      }
      ebs(value) {
        var tmp0 = this.vb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var value_0 = !value;
        tmp0.kb7_1.disabled = value_0;
      }
      fbs() {
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var tmp = this.vb5_1.bb4_1.kb7_1.disabled;
        var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null;
        return !(tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs);
      }
    }
    initMetadataForClass($, 'FormattedTextInput');
    FormattedTextInputClass = $;
  }
  return FormattedTextInputClass;
}
//region block: exports
export {
  FormattedTextInput as FormattedTextInput3hltc3nesrzjq,
};
//endregion

//# sourceMappingURL=FormattedTextInput.commonHtml.mjs.map
